module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/logo-coj-en-f6d2882a949db8acd27f88550079d35d.png";